import { Magazine } from "./Magazine";
export { Magazine };
export default Magazine;
